export default {"src":"/_next/static/media/summersquash.aee94aab.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};